import React from 'react';
import styled from 'styled-components';
import Link from 'next/link';

import usePaths from 'src/hooks/use-paths';
import CartItemClass from 'src/state/cart-item';
import { isWeightedProduct } from 'shared/helpers/products';
import ProductImage from 'src/components/product-image';

export const MatchingItem = ({ item }: { item: CartItemClass }): JSX.Element => {
  const { product, option } = item;
  const { href } = usePaths({ product });
  const isWeighted = isWeightedProduct(product);

  const packageOptions =
    product.POSMetaData?.children?.map((child) => ({
      packageQuantity: child?.packageQuantity,
      option: child?.option,
    })) ?? [];
  const hasPrePackageOptions = packageOptions.some((packageOption) => (packageOption.packageQuantity ?? 0) > 1);
  const displayOption = hasPrePackageOptions ? packageOptions[0]?.option : option;

  return (
    <Anchor as={Link} href={href}>
      <ProductImage product={product} width={48} height={48} alt={product.name} />
      {isWeighted && displayOption !== 'N/A' && <Weight>{displayOption}</Weight>}
    </Anchor>
  );
};

const Anchor = styled.a`
  display: block;

  img {
    display: block;
  }
`;

const Weight = styled.span`
  background: #fff;
  border-top-left-radius: var(--dct--customized-radius-md);
  bottom: 0;
  color: #121516;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  padding: 4px 6px 4px 4px;
  position: absolute;
  right: 0;
`;
